import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=84ca6b0a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=84ca6b0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ca6b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ca6b0a')) {
      api.createRecord('84ca6b0a', component.options)
    } else {
      api.reload('84ca6b0a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=84ca6b0a&scoped=true&", function () {
      api.rerender('84ca6b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nQuYF99ZiKh4/JS/comp/Paginate.vue"
export default component.exports